import type { InviteResponse } from "../api/convite";
import type { LumeUIMessage } from "./types";

/**
 * The opening of the conversation a student lands on from a parent's invite
 * (/convite/<token> → /lume/chat?convite=<token>).
 *
 * Both messages exist only in the browser. Saving a user message in the thread
 * would count against the chat quota (mastra-service lume/chat-quota.ts counts
 * stored `role = 'user'` rows), and the student has not said anything yet.
 */
const SEED_ID_PREFIX = "convite-";

export function inviteTokenFromUrl(): string | null {
  const token = new URLSearchParams(window.location.search).get("convite");

  return token !== null && /^[A-Za-z0-9_-]+$/.test(token) ? token : null;
}

export function isSeedMessage(message: LumeUIMessage): boolean {
  return message.id.startsWith(SEED_ID_PREFIX);
}

/** Whether a proposal widget is the invite's own (inviteSeedMessages), not one the agent made. */
export function isSeedToolCall(toolCallId: string): boolean {
  return toolCallId.startsWith(SEED_ID_PREFIX);
}

export function inviteSeedMessages(
  token: string,
  invite: InviteResponse
): LumeUIMessage[] {
  const phrase = invite.subjectsPhrase;
  const proposal = {
    kind: invite.caderno.kind,
    yearId: invite.caderno.yearId,
    title: invite.caderno.title,
    subjects: invite.caderno.subjects,
    examDate: null,
    reason: "Montado a partir do convite que você recebeu.",
  };

  return [
    {
      id: `${SEED_ID_PREFIX}${token}-pedido`,
      role: "user",
      parts: [
        {
          type: "text",
          text: `Quero criar meu caderno para o ENEM com ${phrase}.`,
        },
      ],
    },
    {
      id: `${SEED_ID_PREFIX}${token}-proposta`,
      role: "assistant",
      parts: [
        {
          type: "text",
          text:
            `Oi, ${invite.name}! Quem te convidou já escolheu as matérias: ${phrase}. ` +
            "Montei o caderno com elas. Toque em **Criar e começar** para abrir a sua trilha, " +
            "ou em **Ajustar** para trocar alguma matéria. Se preferir, me diga aqui o que mudar.",
        },
        {
          type: "tool-suggest_caderno",
          toolCallId: `${SEED_ID_PREFIX}${token}`,
          state: "output-available",
          input: proposal,
          output: { widget: "caderno_proposal", ...proposal },
        },
      ],
    },
  ];
}
